import { render } from "./HomeProductCardList.vue?vue&type=template&id=beb1b22a&scoped=true"
import script from "./HomeProductCardList.vue?vue&type=script&lang=js"
export * from "./HomeProductCardList.vue?vue&type=script&lang=js"

import "./HomeProductCardList.vue?vue&type=style&index=0&id=beb1b22a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beb1b22a"]])

export default __exports__